import { render } from "./IconSearch.vue?vue&type=template&id=6d6df800"
import script from "./IconSearch.vue?vue&type=script&lang=ts"
export * from "./IconSearch.vue?vue&type=script&lang=ts"
script.render = render

export default script